// extracted by mini-css-extract-plugin
export default {"submit-btn":"Navbar_submit-btn__hlruv"};